/* eslint-disable camelcase */
import fetch from "@lib/fetch";
import { userInfoCampaignsCacheKey } from "./constants";
import type { UserInfoCampaignsResponse } from "./types";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

/**
 * Fetch user info campaigns by user identifier
 */
export const getUserInfoCampaignsByIdentifier = reactQueryFetcherAdapter(
  userInfoCampaignsCacheKey,
  async (signal, userIdentifier: string): Promise<UserInfoCampaignsResponse> => {
    return fetch(`/apps/user_info_campaigns/${encodeURIComponent(userIdentifier)}`, "GET", undefined, { signal });
  }
);
